import { Alert, AlertTitle, Button, Card, Grid, IconButton, Stack, TextField } from '@mui/material';
import Container from '@mui/material/Container';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
// Button Link
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { v4 as idv4 } from 'uuid';

//Component
import { useContext } from 'react';
import {TodoContexts } from '../context/TodoContext';
import Todo from './Todo';
import { useEffect, useState } from 'react';


export default function TodoList() {
  
const {todoses,settodos}=useContext(TodoContexts);
const [inputtitle,settitleinput]=useState('');
const [typebutton,settype]=useState('all','complated','Notcomplated')



// fiilter Arraies
const isCompletedType=todoses.filter((com)=>{
  return com.isCompleted;
});
const isNotCompletedType=todoses.filter((com)=>{
  return !com.isCompleted;
});


let todoRender=todoses;
if(typebutton=='complated'){
todoRender=isCompletedType;
}else if(typebutton=='Notcomplated'){
todoRender=isNotCompletedType;
}else if(typebutton=='all'){
  todoRender=todoses;
}
const todos=todoRender.map((d)=>{
  return <div key={d.id}>
  <Todo Todo={d} inpute={inputtitle}/>
</div> });


  function handleChange(e){
settype(e.target.value);
}
  
  function handlAdd(){
    if(inputtitle==''){
      
    }
    else{
      const AddTodo={
        id:idv4(),
       title:inputtitle,
       details:'',
       isCompleted:false
     };  
   settodos([...todoses,AddTodo]);
     localStorage.setItem('todo',JSON.stringify([...todoses,AddTodo]));
     settitleinput('');
     }
}
  useEffect(()=>{

const date=JSON.parse(localStorage.getItem('todo'))??[];

settodos(date);
  },[]);

  return (
 
      <Container  maxWidth="sm">

      <Card variant="outlined">
       
<CardContent style={{ 
        maxHeight:'80vh' ,
       }}>
      <Typography variant='h2' fontWeight={'bold'}>
        مهامي
      </Typography>
       <Divider/>

       {/* FILTER BUTTON */}
<ToggleButtonGroup
style={{ marginTop:'1rem' }}
      color="primary"
        value={typebutton}
      exclusive
        onChange={handleChange}
      aria-label="Platform"
      >
      <ToggleButton  style={{ color:'red',fontWeight:'bold',fontSize:'20px' }} value="all" >الكل</ToggleButton>
      <ToggleButton  style={{ color:'red',fontWeight:'bold',fontSize:'20px' }} value="complated" >المنجزة</ToggleButton>
      <ToggleButton  style={{ color:'red',fontWeight:'bold',fontSize:'20px',borderLeft:'1px solid burlywood' }} value="Notcomplated" >الغير منجزة</ToggleButton>
</ToggleButtonGroup>
   {/* ==== FILTER BUTTON === */}

<div style={{ 
        maxHeight:'50vh' ,
        overflow:'scroll'
       }}>
{todos}

</div>



{/* Inpute + AddButton */}
 <Grid container spacing={1} sx={{ marginTop:'1rem' }}> 
        <Grid size={8}  sx={{ backgroundColor:'black',}}>
          <TextField  label="عنوان المهمة" 
           sx={{backgroundColor:'white',
            width:'100%',
          }}
          value={inputtitle}
          onChange={(event)=>{
            settitleinput(event.target.value)
          }}
           variant="filled" />
        </Grid>
        <Grid size={4}  sx={{ backgroundColor:'blue',}} >
        <Button 
        sx={{width:'100%',
        height:'100%',
        backgroundColor:'rgba(00,95,10,10)',
        fontSize:'20px' }} 
        style={{ color:'white' }}
        variant='contained'
       disabled={inputtitle==''?true:false} onClick={()=>{
          handlAdd();
        }} >
          اضافة</Button>

        </Grid>
   </Grid>
{
//    <Stack sx={{ width: '20%',position:'absolute',bottom:'10px',left:'0',textAlign:'right' }} spacing={2}>
//           <Alert severity="success">
//   <AlertTitle sx={{ fontSize:'20px',fontWeight:'bold',marginRight:'1rem' }}>تم بنجاح</AlertTitle>
//   <span style={{  }}>تمت عملية اضافة المهمة بنجاح </span>
// </Alert>
//   </Stack>
}


{/* == Inpute + AddButton == */}
    </CardContent>
   
      </Card>
    
    
      </Container>
 
  );
}